import React from "react"
import { Link } from "react-router-dom"
import Footer from "./Footer"
import Navbar from "./Navbar"
function About() {
  return (
    <div>
      <Navbar />
      <section className='bg-white '>
        <div className='container px-6 py-10 mx-auto'>
          <h1 className='text-3xl font-semibold text-gray-800 capitalize lg:text-4xl dark:text-white'>
            COMMERCIAL BANK OF ETHIOPIA:
          </h1>
          <h2>THE BANK YOU ALWAYS RELY ON!! COMMERCIAL BANK OF ETHIOPIA</h2>

          <div className='grid grid-cols-1 gap-8 mt-8 md:mt-16 md:grid-cols-2'>
            <div className='lg:flex'>
              <div className='flex flex-col justify-between py-6 lg:mx-6'>
                <Link
                  to='/'
                  className='text-xl font-semibold text-gray-800 hover:underline '
                >
                  ABOUT CBE
                </Link>
                <p>
                  The history of Commercial Bank of Ethiopia (CBE) dates back to
                  the establishment of the State Bank of Ethiopia in 1942. CBE
                  was legally established as a share company in 1963. In 1974,
                  CBE merged with the privately owned Addis Ababa Bank. Since
                  then, it has been playing signiﬁcant roles in the development
                  of the country. For your good financial institution’s Anti Money Laundering: Counter the financing of Terrorism; and know your customer inquiries; we kindly confirm that the Commercial Bank of Ethiopia (CBE) is wholly state owned.

                  Currently CBE has more than 37.9 million account holders in its more than 1900 branches and the number of Mobile and Internet Banking users also reached more than 6.6 million and 37K respectively. Active ATM card holders reached more than 8.3 million and 17 million CBE Birr users.
                </p>
              </div>
            </div>
            <div className='lg:flex'>
              <div className='flex flex-col justify-between py-6 lg:mx-6'>
                <Link
                  to='/'
                  className='text-xl font-semibold text-gray-800 hover:underline'
                >
                  VISION
                </Link>
                <p>
                A world-class commercial bank financially driving Ethiopia's future.
                </p>
    

                <span className='text-sm text-gray-500 dark:text-gray-300'></span>
              </div>
              <div className='flex flex-col justify-between py-6 lg:mx-6'>
                <Link
                  to='/'
                  className='text-xl font-semibold text-gray-800 hover:underline '
                >
                  Mission
                </Link>
                <p>
                  We are committed to realize stakeholder’s values through
                  enhanced financial intermediation using the best professionals
                  and technology.
                </p>
                <span className='text-sm text-gray-500 dark:text-gray-300'></span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  )
}

export default About
